<template>
    <b-button
        variant="primary"
        @click="toAtualizar()"
        v-if="mostrarBtnAtualizar"
        >Atualizar</b-button
    >
</template>

<script>
export default {
    props: {
        unidadeRegional: {
            type: Object
        }
    },

    methods: {
        toAtualizar() {
            this.$router.push({
                name: 'AppSebrae_Consultorias_UnidadesRegionais_Atualizar',
                params: {
                    unidadeRegionalId: this.unidadeRegional.unidadeRegionalId
                }
            })
        }
    },

    computed: {
        mostrarBtnAtualizar() {
            return this.$temAcessoView('APPSE-CONS-UR-03')
        }
    }
}
</script>